var Webflow = Webflow || [];
Webflow.push(function () {
  // DOMready has fired
  // May now use jQuery and Webflow api

  gsap.registerPlugin(ScrollTrigger);

  // Header animations

  var headersTimeline = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.section_header',
        scrub: true,
        start: 'top top',
        end: 'bottom top',
      },
    })
    .to(
      '.w-background-video',
      {
        scale: 1.1,
      },
      '>'
    )
    .to(
      '.header33_content',
      {
        autoAlpha: 0,
      },
      '<'
    );

  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis();

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
});
